import React, { useState } from 'react'
import NativeButton from '@mui/material/Button'
import DarkGreenArrow from 'assets/images/dark-green-arrow.svg'
import GreenArrow from 'assets/images/green-arrow.svg'
import { css, StyleSheet } from 'aphrodite'

interface CliniquesSliderNavArrowProps {
  action: () => void,
  alt: string,
  left?: boolean,
}
const CliniquesSliderNavArrow = ({ action, alt, left }: CliniquesSliderNavArrowProps) => {
  const [isHover, setIsHover] = useState(false)
  const width = isHover ? 28 : 24
  const styles = StyleSheet.create({
    arrow: {
      width,
      height: 24,
      transform: left ? 'scaleX(-1)' : 'scaleX(1)',
      transition: 'all 0.5 ease-in-out',
    },
  })
  const handleHover = () => setIsHover(true)
  const handleOut = () => setIsHover(false)
  return (
    <NativeButton className="tw-flex tw-items-center" onClick={action} onMouseOver={handleHover} onMouseOut={handleOut}>
      <img src={isHover ? DarkGreenArrow : GreenArrow} alt={alt} className={css(styles.arrow)} />
    </NativeButton>
  )
}
CliniquesSliderNavArrow.defaultProps = {
  left: true,
}
export default CliniquesSliderNavArrow
